import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { OnSiteLocationsService } from '@core/services/on-site-locations/on-site-locations.service';

import {
  CHECK_DETAILS_BLOCK_LOADING_VM,
  CheckDetailsBlockDataSource,
  CheckDetailsBlockViewModel,
} from './check-details-block-view-model';

@Injectable()
export class CheckDetailsBlockStoreDataSource implements CheckDetailsBlockDataSource {
  readonly vm$: Observable<CheckDetailsBlockViewModel> = this.activatedRoute.url.pipe(
    switchMap(url => {
      const checkId = url[1]?.path;
      if (!checkId) {
        return of(CHECK_DETAILS_BLOCK_LOADING_VM);
      }

      return this.onSiteLocationsService.getUserCheck$(checkId).pipe(
        map(check => ({ check })),
        catchError(() => of(CHECK_DETAILS_BLOCK_LOADING_VM)),
      );
    }),
  );

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly onSiteLocationsService: OnSiteLocationsService,
  ) {}
}
